<template>
  <div class="soha-resume-card bg-white">
    <div class="row soha-resume-card-info mx-0">
      <div class="col-lg-3 col-md-3 col-sm-3 col-12 m-auto p-0">
        <soha-avatar
          :base-url="
            resumeData.imageFile ? this.$filesUrl : this.$jobseekerImageUrl
          "
          :image-url="
            resumeData.imageFile
              ? resumeData.imageFile.path
              : resumeData.imageUser
          "
          :size="80"
          :gender="resumeData.genderId"
          :color-hash-input="resumeData.fullName"
        />
      </div>
      <div class="col-lg-9 col-md-9 col-sm-9 col-12">
        <div class="d-flex justify-content-between mt-2">
          <router-link
            :to="{ name: 'resume-detail', query: { id: resumeData.id } }"
          >
            <h4
              class="my-auto soha-resume-card-name"
              :id="`name-${resumeData.id}`"
            >
              {{ limitedFullName }}
            </h4>
          </router-link>

          <soha-tooltip
            v-if="resumeData.fullName.length > 25"
            :target="`name-${resumeData.id}`"
            :text="resumeData.fullName"
          />
          <soha-menu icon="info" borderColor="box-border">
            <template v-slot:activator>
              <soha-button-icon
                icon="info"
                borderSize="1"
                borderColor="box-border"
                small
              ></soha-button-icon>
            </template>
            <soha-list>
              <soha-list-item
                @click="$emit('sendMessage', resumeData.id)"
                :text="$t(`${I18nPrefix}SEND_MESSAGE`)"
                icon="mail"
              ></soha-list-item>
            </soha-list>
          </soha-menu>
        </div>
        <div class="mt-2">
          <div class="d-flex mt-2">
            <span class="svg-icon svg-icon-secondary mr-2">
              <inline-svg src="/media/svg/soha/icons/bag.svg" />
            </span>
            <label class="my-auto">{{ $t(`${I18nPrefix}JOB_TITLE`) }} :</label>
            <p class="soha-resume-job-title" :id="`title-${resumeData.id}`">
              {{ limitedJobTitle }}
            </p>
            <soha-tooltip
              v-if="resumeData.job.title.length > 25"
              :target="`title-${resumeData.id}`"
              :text="resumeData.job.title"
            />
          </div>
          <div class="mt-2">
            <span class="svg-icon svg-icon-secondary mr-2">
              <inline-svg src="/media/svg/soha/icons/calendar.svg" />
            </span>
            <label>{{ $t(`${I18nPrefix}RECEIVED_DATE`) }} :</label>
            <span class="soha-resume-receive-date">
              {{ gregorianToJalali(resumeData.created_at) }}
            </span>
          </div>
          <div class="mt-2" v-if="resumeData.pivot?.updated_at">
            <span class="svg-icon svg-icon-secondary mr-2">
              <inline-svg src="/media/svg/soha/icons/calendar.svg" />
            </span>
            <label>{{ $t(`${I18nPrefix}ASSIGN_DATE`) }} :</label>
            <span class="soha-resume-receive-date">
              {{ gregorianToJalali(resumeData.pivot.updated_at) }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row px-4 align-items-center">
      <div v-if="resumeData.resumeTags.length === 0" class="pt-2">
        <soha-tag-resume
          fullText
          :label="$t(`${I18nPrefix}NO_TAG`)"
          color="gray"
        />
      </div>
      <div v-for="(tag, index) in tags" :key="index" v-else class="mx-2 pt-2">
        <soha-tag-resume
          :fullText="isShownAllTags"
          :limitTextShow="8"
          :label="tag.name"
          :color="tag.tagColor?.name ?? ''"
        />
      </div>
      <div v-if="resumeData.resumeTags.length > 3" class="pt-2">
        <div
          class="soha-close-tag-container"
          v-if="isShownAllTags"
          @click="closeAllTags()"
        >
          <div class="soha-close-tag-btn">
            <img
              width="10"
              height="10"
              src="/media/svg/soha/icons/arrow-right-no-tail.svg"
            />
          </div>
        </div>
        <div class="soha-remaining-text-tag" v-else @click="showAllTags()">
          {{ toPersianDigits(resumeData.resumeTags.length - 3) + "+ " }}
          <span class="soha-other-tag-text">
            {{ $t(`${I18nPrefix}OTHER_TAG`) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/components/resume/resume-card.css";
import UIMixin from "@/mixins/UIMixin";
import GeneralMixin from "@/mixins/GeneralMixin";
export default {
  name: "ResumeCard",

  props: {
    resumeData: Object,
  },

  mixins: [UIMixin, GeneralMixin],

  data() {
    return {
      I18nPrefix: "COMPONENTS.RESUME.RESUME_CARD.",
      isShownAllTags: false,
      tags: [],
    };
  },

  mounted() {
    this.createTagsList();
  },

  methods: {
    createTagsList() {
      this.tags = this.resumeData.resumeTags.slice(0, 3);
    },

    showAllTags() {
      this.tags = this.resumeData.resumeTags;
      this.isShownAllTags = true;
    },

    closeAllTags() {
      this.tags = this.resumeData.resumeTags.slice(0, 3);
      this.isShownAllTags = false;
    },
  },

  computed: {
    limitedFullName() {
      if (this.resumeData.fullName?.length > 25) {
        return this.resumeData.fullName.substring(0, 25) + "...";
      } else return this.resumeData.fullName;
    },

    limitedJobTitle() {
      if (this.resumeData.job.title.length > 25) {
        return this.resumeData.job.title.substring(0, 25) + "...";
      } else return this.resumeData.job.title;
    },
  },
};
</script>
